import { faMoon, faSun } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'framework/button';

import cn from './ButtonPage.module.scss';

export default () => {
  return (
    <div className={cn.wrapper}>
      <div className={cn.buttons}>
        <Button disabled>Button</Button>
        <Button shadow>Button</Button>
        <Button left_icon={faMoon} right_icon={faSun}>
          Button
        </Button>
      </div>
      <div className={cn.buttons}>
        <Button variant="secondary" disabled>
          Button
        </Button>
        <Button variant="secondary" shadow>
          Button
        </Button>
        <Button variant="secondary" left_icon={faMoon} right_icon={faSun}>
          Button
        </Button>
      </div>
    </div>
  );
};
